
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7562"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7562"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("js6nX", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("6DLD8"),
    $parcel$import("6czVN"),
    $parcel$import("8BWWq"),
    $parcel$import("dKkyf"),
    $parcel$import("1lfJ7"),
    $parcel$import("eyJKn"),
    $parcel$import("4ii86"),
    $parcel$import("4gxht"),
    $parcel$import("hTQYL")
]).then(()=>parcelRequire('9AL2r'));

});

var $93b22ff38ca58b0f$exports = {};
$parcel$extendImportMap({
    "36550": "gitGraphDiagram-IHSO6WYX.b750edfa.js",
    "hTQYL": "mermaid.core.3aaff008.js",
    "kkB48": "dagre-VKFMJZFB.6698bb92.js",
    "4gxht": "mermaid.core.c4022d2d.js",
    "8lKXy": "katex.afe57354.js",
    "4ii86": "mermaid.core.e9d0e0f6.js",
    "1lfJ7": "mermaid.core.b592de62.js",
    "dKkyf": "mermaid.core.da438ba3.js",
    "8BWWq": "mermaid.core.a964ec6c.js",
    "6czVN": "mermaid.core.d9dea16c.js",
    "6DLD8": "mermaid.core.7386b3a5.js",
    "7AVZF": "dagre-VKFMJZFB.6a7f73d0.js",
    "870rC": "dagre-VKFMJZFB.c7898e4d.js",
    "jeryV": "dagre-VKFMJZFB.c68d2c31.js",
    "6yknc": "dagre-VKFMJZFB.ee16c042.js",
    "6ZPCw": "swimlanes-5IMT3BWC.79319c3e.js",
    "n2GgU": "sizeCapture-X5ZJPWSS.d9df8f96.js",
    "iK9oI": "cose-bilkent-JH36ORCC.2436dc69.js",
    "hvYMz": "cose-bilkent-JH36ORCC.b04560fe.js",
    "dVrmK": "c4Diagram-LMCZKHZV.35e18cf7.js",
    "3WI3D": "flowDiagram-23GEKE2U.40801dc4.js",
    "eyJKn": "mermaid.core.ccfcc3ca.js",
    "cssaW": "flowDiagram-23GEKE2U.67bdcb43.js",
    "4j8y4": "swimlanesDiagram-G3AALYLV.9bcfbc40.js",
    "7eFbY": "erDiagram-Q63AITRT.409bc758.js",
    "5oGEL": "gitGraphDiagram-IHSO6WYX.a6dad767.js",
    "9oxYd": "info-DKCQHKI2.006380bd.js",
    "f8Jsz": "packet-7NZHBO7P.aa550c24.js",
    "8EK8b": "pie-RZYD4A2V.775698f7.js",
    "9DIcC": "treeView-QDETBFTQ.b631bab7.js",
    "eYMU4": "architecture-TIHT7OUA.66715039.js",
    "hU3H4": "gitGraph-TEB2WS4Q.41a3e422.js",
    "kXPc9": "eventmodeling-45OFAUF4.7187ed95.js",
    "4FOOB": "radar-I7S5WNFK.962e502a.js",
    "iHttW": "railroad-3IZDKUUU.c98c1487.js",
    "7476I": "railroad-ebnf-EBAXGLYW.d6b4a220.js",
    "2KUk9": "railroad-abnf-AHOZXSZD.b8d9c2e2.js",
    "9I3jy": "railroad-peg-LSFZ7HO6.1c1130be.js",
    "d28nA": "treemap-6X3UGDF4.060277da.js",
    "5Rp7m": "wardley-OPB4EBWU.2fda19ed.js",
    "8xNyx": "cynefin-VYW2F7L2.10fe3892.js",
    "k0opC": "ganttDiagram-NO4QXBWP.d384e09f.js",
    "6Rz4J": "infoDiagram-FWYZ7A6U.5f9b7f4f.js",
    "fT286": "pieDiagram-ENE6RG2P.282c2cd5.js",
    "iZlyW": "quadrantDiagram-ABIIQ3AL.c994fe3f.js",
    "9uziT": "xychartDiagram-FW5EYKEG.436a6146.js",
    "5s2ws": "requirementDiagram-TGXJPOKE.e2c5282d.js",
    "10sMQ": "sequenceDiagram-DBY2YBRQ.f52644d1.js",
    "1aH4d": "classDiagram-OUVF2IWQ.939eec73.js",
    "8t3HY": "classDiagram-OUVF2IWQ.31c903b1.js",
    "BsLzf": "classDiagram-v2-EOCWNBFH.cde87261.js",
    "cKe26": "stateDiagram-2N3HPSRC.b3fe8f21.js",
    "4Wkmu": "stateDiagram-2N3HPSRC.86e5978e.js",
    "jeIhU": "stateDiagram-v2-6OUMAXLB.75ac55f2.js",
    "7XJll": "journeyDiagram-5HDEW3XC.503fbef3.js",
    "5JElw": "timeline-definition-FHXFAJF6.33d71a8b.js",
    "2JIuE": "mindmap-definition-LN4V7U3C.bb98ca76.js",
    "7uXSB": "kanban-definition-HUTT4EX6.c77f58a1.js",
    "eqbEz": "sankeyDiagram-HTMAVEWB.3e07a1a9.js",
    "8hSPH": "diagram-NH7WQ7WH.c503fee9.js",
    "dyGlG": "diagram-WEI45ONY.0a76a01b.js",
    "iHvom": "blockDiagram-677ZJIJ3.1295e938.js",
    "cBMbg": "diagram-OA4YK3LP.864652f0.js",
    "59qAO": "architectureDiagram-ZJ3FMSHR.fd072ed4.js",
    "7rtbu": "diagram-FQU43EPY.01e70411.js",
    "3Xoc4": "ishikawaDiagram-FXEZZL3T.988fe7ea.js",
    "kNGoA": "vennDiagram-L72KCM5P.aa3490d8.js",
    "lhUiu": "diagram-G47NLZAW.7076aa98.js",
    "kEUM2": "wardleyDiagram-EHGQE667.66a975fc.js",
    "h9oK3": "cynefinDiagram-TSTJHNR4.91142650.js",
    "gxK5i": "railroadDiagram-RFXS5EU6.aaa6c896.js",
    "9l2L6": "railroadDiagram-RFXS5EU6.fbb48ef7.js",
    "2VCYo": "ebnfDiagram-CCIWWBDH.ee05b60d.js",
    "eDJtb": "abnfDiagram-VRR7QNED.4527b731.js",
    "gizZn": "pegDiagram-2B236MQR.6030fd6b.js"
});

function $d9f5622067590c45$export$85772d84a864c759(callback, options) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", callback, options);
    else callback();
}



const $379e7eef62e919cc$export$e2286f890a67816d = "custom-track-action";
function $379e7eef62e919cc$export$d60905acb4dc9db9(element, payload) {
    try {
        const event = new CustomEvent($379e7eef62e919cc$export$e2286f890a67816d, {
            bubbles: true,
            cancelable: false,
            detail: payload
        });
        element.dispatchEvent(event);
    } catch (e) {
        console.warn("Failed to dispatch custom event, error: ", e);
    }
}


// https://umami.is/docs/api/sending-stats
function $ee0e91bbd85d4a5a$export$b51944af968afad3() {
    const context = $ee0e91bbd85d4a5a$var$buildContext();
    if (!context) console.log("Umami is disabled by policy.");
    const track = async (payload)=>{
        if (context) {
            const mergedData = {
                ...payload?.data,
                ...context.defaultPayload.data
            };
            const mergedPayload = {
                ...context.defaultPayload,
                ...payload,
                data: mergedData
            };
            await fetch(context.settings.endpoint, {
                method: "POST",
                body: JSON.stringify({
                    payload: mergedPayload,
                    type: "event"
                }),
                headers: {
                    "Content-Type": "application/json"
                }
            });
        } else console.log("Umami is disabled and would have sent event ", payload ?? {});
    };
    return {
        enabled: !!context,
        trackView: ()=>track(),
        trackEvent: (name, data)=>track({
                name: name,
                data: data
            })
    };
}
function $ee0e91bbd85d4a5a$var$buildContext() {
    // This all assumes this is not a single page application.
    // Reduces code substantially.
    // Merge all script data attributes.
    let data = {};
    for(let i = 0; i < document.scripts.length; i++){
        const script = document.scripts[i];
        data = {
            ...data,
            ...script.dataset
        };
    }
    // Settings
    const allowedDomains = data?.umamiDomains?.split(",").map((x)=>x.trim().toLowerCase()) ?? [];
    const websiteId = data?.umamiWebsiteId?.trim();
    const endpoint = data?.umamiEndpoint?.trim();
    // Enabled
    const enabled = !!websiteId && !!endpoint && (allowedDomains.length == 0 || allowedDomains.includes(location.hostname)) && $ee0e91bbd85d4a5a$var$isUmamiAllowedByPolicy();
    if (enabled) {
        const settings = {
            allowedDomains: allowedDomains,
            websiteId: websiteId,
            endpoint: endpoint
        };
        // Matches https://github.com/umami-software/umami/blob/master/src/tracker/index.js
        const defaultPayload = {
            website: websiteId,
            hostname: window.location.hostname,
            screen: `${window.screen.width}x${window.screen.height}`,
            language: window.navigator.language,
            title: $ee0e91bbd85d4a5a$var$encode(document.title),
            url: $ee0e91bbd85d4a5a$var$encode($ee0e91bbd85d4a5a$var$getPathAndSearch(location.href)),
            referrer: document.referrer !== document.location.hostname // Not sure when this would ever be false?
             ? $ee0e91bbd85d4a5a$var$encode(document.referrer) : "",
            data: {
                prefersDarkMode: !!window?.matchMedia?.("(prefers-color-scheme:dark)")?.matches
            }
        };
        return {
            settings: settings,
            defaultPayload: defaultPayload
        };
    }
}
function $ee0e91bbd85d4a5a$var$isUmamiAllowedByPolicy() {
    const disabledByLocalStorage = localStorage.getItem("umami.disabled");
    return !disabledByLocalStorage;
}
function $ee0e91bbd85d4a5a$var$encode(str) {
    if (!str) return undefined;
    try {
        const result = decodeURI(str);
        if (result !== str) return result;
    } catch  {
        return str;
    }
    return encodeURI(str);
}
function $ee0e91bbd85d4a5a$var$getPathAndSearch(url) {
    try {
        const { pathname: pathname, search: search } = new URL(url);
        url = pathname + search;
    } catch  {
    /* empty */ }
    return url;
}


// Hoisted as a micro-optimization to reduce uncompressed bundle size.
const $f96e0bd4768b5207$var$eventListenerOptions = {
    passive: true // Run events async.
};
function $f96e0bd4768b5207$export$b2a38ad57afb6dbd() {
    (0, $d9f5622067590c45$export$85772d84a864c759)(()=>{
        if (document.location.search?.includes("no-umami")) localStorage.setItem("umami.disabled", "1");
        // Only build umami after the DOM is fully ready.
        // To avoid race conditions around things like Title.
        // As always, this assumes all this is running
        // with tradition hyperlink navigation.
        const umami = (0, $ee0e91bbd85d4a5a$export$b51944af968afad3)();
        addEventListener("hashchange", ()=>{
            $f96e0bd4768b5207$var$onHashChange(umami);
        }, $f96e0bd4768b5207$var$eventListenerOptions);
        addEventListener("visibilitychange", ()=>{
            $f96e0bd4768b5207$var$onVisibilityChange(umami);
        }, $f96e0bd4768b5207$var$eventListenerOptions);
        addEventListener("click", ({ target: target })=>{
            $f96e0bd4768b5207$var$onLinkClick(target, umami);
        }, $f96e0bd4768b5207$var$eventListenerOptions);
        addEventListener("contextmenu", ({ target: target })=>{
            $f96e0bd4768b5207$var$onLinkClick(target, umami);
        }, $f96e0bd4768b5207$var$eventListenerOptions);
        window.addEventListener((0, $379e7eef62e919cc$export$e2286f890a67816d), (e)=>{
            const customEvent = e;
            const payload = customEvent.detail;
            $f96e0bd4768b5207$var$onCustomAction(umami, payload);
        }, $f96e0bd4768b5207$var$eventListenerOptions);
        $f96e0bd4768b5207$var$attachPresenceHandler(umami);
        $f96e0bd4768b5207$var$onReady(umami);
        $f96e0bd4768b5207$var$onHashChange(umami);
    }, $f96e0bd4768b5207$var$eventListenerOptions);
}
async function $f96e0bd4768b5207$var$onReady(umami) {
    await umami.trackView();
}
async function $f96e0bd4768b5207$var$onHashChange(umami) {
    if (location.hash) await umami.trackEvent("anchor-used", {
        link: window.location.pathname + location.hash
    });
}
async function $f96e0bd4768b5207$var$onVisibilityChange(umami) {
    await umami.trackEvent("visibility-changed", {
        hidden: document.hidden
    });
}
async function $f96e0bd4768b5207$var$onLinkClick(target, umami) {
    // Walk upwards until either the root or an anchor.
    // ^ Actually, not sure this is needed, events should bubble.
    while(target && target instanceof Element && !(target instanceof HTMLAnchorElement))target = target.parentNode;
    if (target instanceof HTMLAnchorElement && target.rel.includes("external")) await umami.trackEvent("external-link", {
        page: window.location.pathname,
        href: target.href
    });
}
async function $f96e0bd4768b5207$var$onCustomAction(umami, data) {
    await umami.trackEvent(data.name, {
        page: window.location.pathname,
        ...data.data
    });
}
function $f96e0bd4768b5207$var$attachPresenceHandler(umami) {
    const state = {
        presenceEvents: 0
    };
    async function onSessionDurationChanged(umami) {
        if (state.presenceEvents < 30) {
            await umami.trackEvent("presence", {
                page: window.location.pathname
            });
            state.presenceEvents++;
        }
    }
    function createInterval() {
        return setInterval(()=>{
            onSessionDurationChanged(umami);
        }, 60000);
    }
    const timerState = {};
    timerState.intervalId = createInterval();
    addEventListener("visibilitychange", ()=>{
        const hidden = document.visibilityState === "hidden";
        if (hidden) {
            if (timerState.intervalId) {
                clearInterval(timerState.intervalId);
                timerState.intervalId = undefined;
            }
        } else if (!timerState.intervalId) timerState.intervalId = createInterval();
    }, $f96e0bd4768b5207$var$eventListenerOptions);
}




function $18c7caa0593c5ada$export$cdc50be98fe06694() {
    (0, $d9f5622067590c45$export$85772d84a864c759)(()=>{
        const copyButtons = document.querySelectorAll("[data-for-code-id]");
        for (const button of copyButtons)if (button instanceof HTMLElement) {
            button.addEventListener("click", ()=>{
                $18c7caa0593c5ada$var$onCopyClick(button);
            });
            button.style.visibility = ""; // Unhide the button, since JS can load.
        }
    }, {
        passive: true
    });
}
async function $18c7caa0593c5ada$var$onCopyClick(button) {
    const codeId = button.dataset.forCodeId;
    if (codeId) {
        const codeBlock = document.getElementById(codeId);
        const text = codeBlock?.textContent;
        if (text) {
            const success = await $18c7caa0593c5ada$var$copyToClipboard(text);
            if (success) $18c7caa0593c5ada$var$showCopiedTooltip(button);
            (0, $379e7eef62e919cc$export$d60905acb4dc9db9)(button, {
                name: "code-copied",
                data: {
                    success: success,
                    page: `${window.location.pathname}#${codeId}`
                }
            });
        }
    }
}
async function $18c7caa0593c5ada$var$copyToClipboard(text) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (e) {
        console.warn("Failed to copy text to the clipboard, error: ", e);
        return false;
    }
}
function $18c7caa0593c5ada$var$showCopiedTooltip(button) {
    const originalLabel = button.ariaLabel;
    // Open
    button.ariaLabel = "Copied";
    button.dataset.showCopied = "true";
    // Close
    setTimeout(()=>{
        button.ariaLabel = originalLabel;
        delete button.dataset.showCopied;
    }, 2000);
}



const $eb4bd5b0ce518deb$var$BackdropId = "lightbox-backdrop";
const $eb4bd5b0ce518deb$var$TailwindAnimationTimeoutMs = 150;
function $eb4bd5b0ce518deb$export$da6999f6ea7f41bd() {
    (0, $d9f5622067590c45$export$85772d84a864c759)(()=>{
        addEventListener("click", (event)=>{
            if (event.target instanceof HTMLElement && event.target.classList.contains("lightbox-subject")) {
                console.log(event);
                $eb4bd5b0ce518deb$var$toggleLightbox(event.target);
            }
        });
    });
}
function $eb4bd5b0ce518deb$var$toggleLightbox(target) {
    if ($eb4bd5b0ce518deb$var$isLightboxOpen(target)) $eb4bd5b0ce518deb$var$closeLightbox(target);
    else $eb4bd5b0ce518deb$var$openLightbox(target);
}
function $eb4bd5b0ce518deb$var$openLightbox(target) {
    if ($eb4bd5b0ce518deb$var$isLightboxOpen(target)) return;
    target.dataset.lightbox = "open";
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const targetBounds = target.getBoundingClientRect();
    // If no width/height attribute exists (added by the image processing pipeline),
    // then do not attempt to clamp on the in intrinsic size (to support light-boxing non-images).
    const idealWidth = target.hasAttribute("width") ? parseInt(target.getAttribute("width")) : Number.MAX_SAFE_INTEGER;
    const idealHeight = target.hasAttribute("height") ? parseInt(target.getAttribute("height")) : Number.MAX_SAFE_INTEGER;
    const translateX = viewportWidth / 2 - targetBounds.left - targetBounds.width / 2;
    const translateY = viewportHeight / 2 - targetBounds.top - targetBounds.height / 2;
    const margin = 40;
    const scale = Math.min(// Clamp on viewport size.
    viewportWidth / (targetBounds.width + margin), viewportHeight / (targetBounds.height + margin), // Clamp on the resolution of the image.
    idealWidth / targetBounds.width, idealHeight / targetBounds.height);
    target.classList.add("open");
    target.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale * 100}%)`;
    target.style.zIndex = "10";
    const backdrop = $eb4bd5b0ce518deb$var$openLightboxBackdrop();
    backdrop.addEventListener("click", ()=>$eb4bd5b0ce518deb$var$closeLightbox(target), {
        once: true,
        passive: true
    });
    addEventListener("scroll", ()=>$eb4bd5b0ce518deb$var$closeLightbox(target), {
        once: true,
        passive: true
    });
    addEventListener("resize", ()=>$eb4bd5b0ce518deb$var$closeLightbox(target), {
        once: true,
        passive: true
    });
}
function $eb4bd5b0ce518deb$var$closeLightbox(target) {
    if (!$eb4bd5b0ce518deb$var$isLightboxOpen(target)) return;
    delete target.dataset.lightbox;
    target.style.transform = "";
    target.classList.remove("open");
    $eb4bd5b0ce518deb$var$closeLightboxBackdrop();
    setTimeout(()=>{
        // Avoid a dirty write.
        if (!$eb4bd5b0ce518deb$var$isLightboxOpen(target)) target.style.zIndex = "";
    }, $eb4bd5b0ce518deb$var$TailwindAnimationTimeoutMs);
}
function $eb4bd5b0ce518deb$var$isLightboxOpen(target) {
    return target.dataset.lightbox == "open";
}
function $eb4bd5b0ce518deb$var$openLightboxBackdrop() {
    let lightbox = document.getElementById($eb4bd5b0ce518deb$var$BackdropId);
    if (!lightbox) {
        lightbox = document.createElement("div");
        lightbox.id = $eb4bd5b0ce518deb$var$BackdropId;
        lightbox.classList.add("lightbox-backdrop", "open");
        lightbox.ariaHidden = "";
        document.body.appendChild(lightbox);
    } else lightbox.classList.add("open");
    return lightbox;
}
function $eb4bd5b0ce518deb$var$closeLightboxBackdrop() {
    const lightbox = document.getElementById($eb4bd5b0ce518deb$var$BackdropId);
    if (lightbox) lightbox.classList.remove("open");
    return lightbox;
}



function $4f89e7f94d336506$export$51a6a5db74f13074() {
    (0, $d9f5622067590c45$export$85772d84a864c759)(()=>{
        $4f89e7f94d336506$var$loadMermaid();
    }, {
        passive: true
    });
}

async function $4f89e7f94d336506$var$loadMermaid() {
    const mermaidAreas = document.getElementsByClassName("mermaid");
    if (mermaidAreas.length > 0) {
        const darkMode = !!window?.matchMedia?.("(prefers-color-scheme:dark)")?.matches;
        console.log(`Activating Mermaid for ${mermaidAreas.length} diagrams (dark: ${darkMode})...`);
        // Manual bundle splitting as Mermaid is freaking huge.
        const mermaidFetch = (parcelRequire("js6nX"));
        for (const area of mermaidAreas)$4f89e7f94d336506$var$activateLoading(area);
        const mermaid = (await mermaidFetch).default;
        mermaid.initialize({
            startOnLoad: false,
            darkMode: darkMode,
            sequence: {
                mirrorActors: false // Don't duplicate top actors to the bottom.
            },
            theme: "neutral",
            fontFamily: "Inter Variable",
            altFontFamily: "Inter Regular"
        });
        console.log("Mermaid ready, rendering...");
        for (const area of mermaidAreas)await $4f89e7f94d336506$var$renderDiagram(area, mermaid);
        console.log("All Mermaid diagrams are ready.");
    }
}
function $4f89e7f94d336506$var$activateLoading(area) {
    for (const loading of area.getElementsByClassName("mermaid-loading"))if (loading instanceof HTMLElement) loading.style.opacity = "1";
}
async function $4f89e7f94d336506$var$renderDiagram(area, mermaid) {
    for (const diagram of area.getElementsByClassName("mermaid-diagram"))if (diagram instanceof HTMLElement) {
        await mermaid.run({
            nodes: [
                diagram
            ],
            suppressErrors: true
        });
        diagram.style.opacity = "1";
        diagram.ariaHidden = "true";
    }
    for (const loading of area.getElementsByClassName("mermaid-loading"))if (loading instanceof HTMLElement) loading.style.opacity = "0";
}


const $6f5d2ce710b96ebf$var$registry = new FinalizationRegistry(({ signal: signal, aborted: aborted })=>{
    signal?.removeEventListener('abort', aborted);
});
function $6f5d2ce710b96ebf$export$2e2bcd8739ae039({ limit: limit, interval: interval, strict: strict, signal: signal, onDelay: onDelay }) {
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        // Clear the queue if there's a significant delay since the last execution
        if (strictTicks.length > 0 && now - strictTicks.at(-1) > interval) strictTicks.length = 0;
        // If the queue is not full, add the current time and execute immediately
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        // Calculate the next execution time based on the first item in the queue
        const nextExecutionTime = strictTicks[0] + interval;
        // Shift the queue and add the new execution time
        strictTicks.shift();
        strictTicks.push(nextExecutionTime);
        // Calculate the delay for the current execution
        return Math.max(0, nextExecutionTime - now);
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...arguments_) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, arguments_))();
            let timeoutId;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, arguments_));
                    queue.delete(timeoutId);
                };
                const delay = getDelay();
                if (delay > 0) {
                    timeoutId = setTimeout(execute, delay);
                    queue.set(timeoutId, reject);
                    onDelay?.(...arguments_);
                } else execute();
            });
        };
        const aborted = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(signal.reason);
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        $6f5d2ce710b96ebf$var$registry.register(throttled, {
            signal: signal,
            aborted: aborted
        });
        signal?.throwIfAborted();
        signal?.addEventListener('abort', aborted, {
            once: true
        });
        throttled.isEnabled = true;
        Object.defineProperty(throttled, 'queueSize', {
            get () {
                return queue.size;
            }
        });
        return throttled;
    };
}



function $6fe3afcf9e23cac4$export$5f28c2e4082cfc38() {
    (0, $d9f5622067590c45$export$85772d84a864c759)(()=>{
        const throttle = (0, $6f5d2ce710b96ebf$export$2e2bcd8739ae039)({
            limit: 8,
            interval: 1000,
            onDelay: ()=>console.log("Throttling preload...")
        });
        const preloadLinkThrottled = throttle($6fe3afcf9e23cac4$var$preloadLink);
        const links = document.getElementsByTagName("a");
        for (const link of links)if (!link.relList.contains("external") && !link.getAttribute("href")?.startsWith("#")) link.addEventListener("mouseenter", ()=>{
            preloadLinkThrottled(link.href);
        }, {
            passive: true,
            once: true
        });
    });
}
async function $6fe3afcf9e23cac4$var$preloadLink(link) {
    try {
        await fetch(link, {
            method: "GET",
            cache: "reload",
            mode: "same-origin"
        });
    } catch (error) {
        console.warn(`Failed while preloading '${link}', error: `, error);
    }
}



function $52524cd72bf4a342$export$f1690a6a91515aef() {
    (0, $d9f5622067590c45$export$85772d84a864c759)(()=>{
        $52524cd72bf4a342$export$4e4c441f9a8c48e();
    }, {
        passive: true
    });
    const effectiveMode = $52524cd72bf4a342$var$getEffectiveThemeMode();
    console.log(`Effective theme is '${effectiveMode}'.`);
}
function $52524cd72bf4a342$export$4e4c441f9a8c48e() {
    const toggles = document.getElementsByClassName("theme-toggle");
    for (const toggle of toggles)if (toggle instanceof HTMLElement) $52524cd72bf4a342$var$hydrateToggle(toggle);
}
function $52524cd72bf4a342$var$hydrateToggle(element) {
    element.addEventListener("click", ()=>{
        $52524cd72bf4a342$var$toggleTheme();
    });
}
function $52524cd72bf4a342$var$toggleTheme() {
    const currentTheme = $52524cd72bf4a342$var$getEffectiveThemeMode();
    const nextTheme = currentTheme == "dark" ? "light" : "dark";
    console.log("Switching theme from", currentTheme, "to", nextTheme);
    document.documentElement.classList.remove(currentTheme);
    document.documentElement.classList.add(nextTheme);
    localStorage.setItem("theme", nextTheme);
}
function $52524cd72bf4a342$var$getEffectiveThemeMode() {
    // Check if set by user.
    const configuredTheme = localStorage.getItem("theme");
    if (configuredTheme) {
        if (configuredTheme === "light") return "light";
        else return "dark";
    }
    // Else, pick from user-agent, if possible.
    const perfersDark = !!window?.matchMedia?.("(prefers-color-scheme:dark)")?.matches;
    return perfersDark ? "dark" : "light";
}



function $d5f002b5392428c7$export$96f7a33154c42b3c() {
    (0, $d9f5622067590c45$export$85772d84a864c759)(()=>{
        const toc = document.getElementById("toc-block");
        if (toc) {
            const references = [];
            for (const link of toc.getElementsByTagName("a")){
                const hash = new URL(link.href).hash;
                if (hash) {
                    const id = hash.startsWith("#") ? hash.substring(1) : hash;
                    const header = document.getElementById(id);
                    if (header && header.parentElement?.tagName == "SECTION") {
                        const target = header.parentElement;
                        references.push({
                            id: id,
                            link: link,
                            target: target,
                            visible: false
                        });
                    } else console.warn(`Found link for '#${id}', but no target was found.`);
                }
            }
            if (references.length) {
                const observer = new IntersectionObserver((entries)=>{
                    for (const entry of entries){
                        const ref = references.find((x)=>entry.target === x.target);
                        if (ref) ref.visible = entry.isIntersecting;
                    }
                    let hasActive = false;
                    for (const ref of references)if (ref.visible && !hasActive) {
                        hasActive = true;
                        ref.link.classList.add("active");
                        ref.link.classList.remove("inactive");
                    } else {
                        ref.link.classList.remove("active");
                        ref.link.classList.add("inactive");
                    }
                }, {
                    rootMargin: "10px"
                });
                for (const ref of references)observer.observe(ref.target);
            }
        }
    }, {
        passive: true
    });
}


function $44a0b29e7cc468b0$export$f22da7240b7add18() {
    (0, $f96e0bd4768b5207$export$b2a38ad57afb6dbd)();
    (0, $eb4bd5b0ce518deb$export$da6999f6ea7f41bd)();
    (0, $18c7caa0593c5ada$export$cdc50be98fe06694)();
    (0, $6fe3afcf9e23cac4$export$5f28c2e4082cfc38)();
    (0, $d5f002b5392428c7$export$96f7a33154c42b3c)();
    (0, $4f89e7f94d336506$export$51a6a5db74f13074)();
    (0, $52524cd72bf4a342$export$f1690a6a91515aef)();
    (0, $d9f5622067590c45$export$85772d84a864c759)(()=>{
        console.log("Ready.");
    });
}


(0, $44a0b29e7cc468b0$export$f22da7240b7add18)();


//# sourceMappingURL=404.ee5e49a4.js.map
